// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8b13ce7b","453":"57484a24"}[chunkId] + ".chunk.js";
};